module.exports = __webpack_public_path__ + "static/media/bottom-right-couple.60956527.jpeg";